/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterListItem
 */
export interface GlobalFilterListItem {
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterListItem
     */
    comment?: string | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof GlobalFilterListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof GlobalFilterListItem
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterListItem
     */
    relevance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterListItem
     */
    allowEdit?: boolean;
}

export function GlobalFilterListItemFromJSON(json: any): GlobalFilterListItem {
    return GlobalFilterListItemFromJSONTyped(json, false);
}

export function GlobalFilterListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function GlobalFilterListItemToJSON(value?: GlobalFilterListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'deleted': value.deleted,
        'description': value.description,
        'comment': value.comment,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'allowEdit': value.allowEdit,
    };
}


